module.exports = __webpack_public_path__ + "static/media/20210410_185552_886_IMG_0296.a7014bf5.jpg";